import { render } from "./associations.vue?vue&type=template&id=20d7c9b3&scoped=true"
import script from "./associations.vue?vue&type=script&lang=js"
export * from "./associations.vue?vue&type=script&lang=js"

import "./associations.vue?vue&type=style&index=0&id=20d7c9b3&lang=css"
import "./associations.vue?vue&type=style&index=1&id=20d7c9b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d7c9b3"]])

export default __exports__